var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trbo-a-question-renderer" },
    [
      _c(_vm.pageTypeComponent, {
        key: _vm.question.id,
        tag: "component",
        attrs: {
          question: _vm.question,
          "question-data": _vm.questionData,
          selected: _vm.selected,
          "option-search-query": _vm.optionSearchQuery,
        },
        on: { select: _vm.onSelect, submit: _vm.onSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }